import { all } from "redux-saga/effects";

import globalSagas from "../ducks/global/sagas";
import userSagas from "../ducks/user/sagas";
// import basketSagas from '../ducks/basket/sagas';

export default function* rootSaga() {
  yield all([
    ...globalSagas,
    ...userSagas,
    // ...basketSagas
  ]);
}
